import { render, staticRenderFns } from "./ManagementNetworkDetail.vue?vue&type=template&id=47cc0dba&scoped=true&"
import script from "./ManagementNetworkDetail.vue?vue&type=script&lang=ts&"
export * from "./ManagementNetworkDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cc0dba",
  null
  
)

export default component.exports